import { cnRequest } from './request';

export default cnRequest;
